import { addSheetBackLink, PARENT_SHEETS } from "../sheetNavigation.js";
import {
  BACK_ROW,
  BODY_FONT,
  HEADER_FONT_11,
  HEADER_ROW,
  NA_FILL,
  VALUE_FILL,
  hideColumnsAfter,
  setCell,
} from "./detailSheetCommon.js";
import {
  COL_D,
  COL_E,
  COL_F,
  COL_G,
  COL_H,
  addSheetTitle,
  addTableSpacer,
  applyBorderPattern,
  setupPrinciple2DetailSheet,
  writeDataRow,
} from "./principle2DetailHelpers.js";
import { excelWorksheetName, safeText, toYesNoNa } from "./principle6SheetHelpers.js";

export const SHEET_NAME = "Environment approval (clearance)";

const SHEET_TITLE =
  "If the entity has operations/offices in/around ecologically sensitive areas (such as national parks, wildlife sanctuaries, biosphere reserves, wetlands, biodiversity hotspots, forests, coastal regulation zones etc.) where environmental approvals / clearances are required, please specify details in the following format:";

const WIDTHS = {
  A: 9.1796875,
  B: 9.1796875,
  C: 9.1796875,
  D: 6.26953125,
  E: 34.1796875,
  F: 39.7265625,
  G: 63.7265625,
  H: 59.1796875,
  I: 9.1796875,
  J: 9.1796875,
  K: 9.1796875,
  L: 9.1796875,
};

const TEMPLATE_ROW = 10;
const SPACER_ROW = 11;
const DATA_START_ROW = 12;
const COL_END = COL_H;

const ALL_THIN = ["tttt", "tttt", "tttt", "tttt", "tttt"];

export function buildEnvironmentApprovalSheet(workbook, sectionC) {
  const ws = workbook.addWorksheet(excelWorksheetName(SHEET_NAME), {
    views: [{ showGridLines: false }],
  });

  setupPrinciple2DetailSheet(ws, {
    widths: WIDTHS,
    colEnd: COL_END,
    ySplit: 11,
    topLeftCell: "D12",
    hiddenCols: ["A", "B"],
  });
  hideColumnsAfter(ws, 11);

  addSheetBackLink(ws, PARENT_SHEETS.PRINCIPLE_6, {
    row: BACK_ROW,
    col: COL_END,
    mergeEnd: COL_END,
    align: "right",
    parentCell: "D8",
  });

  addSheetTitle(ws, COL_END, SHEET_TITLE, {
    height: 42.75,
    borderPatterns: ALL_THIN,
  });

  applyBorderPattern(ws, HEADER_ROW, COL_D, ALL_THIN);
  ws.getRow(HEADER_ROW).height = 29;
  [
    { col: COL_D, label: "Sr. No." },
    { col: COL_E, label: "Location of operations/offices" },
    { col: COL_F, label: "Type of operations" },
    {
      col: COL_G,
      label:
        "Whether the conditions of environmental approval / clearance are being complied with?",
    },
    {
      col: COL_H,
      label: "If no, the reasons thereof and corrective action taken, if any.",
    },
  ].forEach(({ col, label }) => {
    setCell(ws, HEADER_ROW, col, label, {
      font: HEADER_FONT_11,
      bold: false,
      bordered: false,
      align: "center",
    });
  });

  applyBorderPattern(ws, TEMPLATE_ROW, COL_D, ALL_THIN);
  for (let col = COL_D; col <= COL_END; col += 1) {
    setCell(ws, TEMPLATE_ROW, col, "", {
      bordered: false,
      font: BODY_FONT,
      fill: col === COL_H ? NA_FILL : undefined,
    });
  }
  ws.getRow(TEMPLATE_ROW).hidden = true;

  addTableSpacer(ws, COL_D, COL_END, { row: SPACER_ROW, height: 30, patterns: ALL_THIN });

  const rows = sectionC?.principle6?.essentialIndicators?.environmentalApproval || [];
  const dataRows = Array.isArray(rows) && rows.length ? rows : [{}];

  dataRows.forEach((item, idx) => {
    const row = DATA_START_ROW + idx;
    const approval = toYesNoNa(item?.approval);
    const reasonFill = approval === "No" ? VALUE_FILL : NA_FILL;
    writeDataRow(
      ws,
      row,
      COL_D,
      COL_END,
      [
        { col: COL_D, value: idx + 1, align: "center", fill: null, font: BODY_FONT },
        {
          col: COL_E,
          value: safeText(item?.location),
          align: "left",
          fill: VALUE_FILL,
        },
        {
          col: COL_F,
          value: safeText(item?.operation),
          align: "left",
          fill: VALUE_FILL,
        },
        { col: COL_G, value: approval, align: "center", fill: VALUE_FILL },
        {
          col: COL_H,
          value: approval === "No" ? safeText(item?.reason, "") : "",
          align: "left",
          fill: reasonFill,
        },
      ],
      { patterns: ALL_THIN }
    );
  });

  return ws;
}
